export default "__VITE_ASSET__DJcdCfhK__"